import { Box, Button, Typography } from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import SejamStatusImage from "../../assets/images/sejam-status.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AuthStatusBox from "../../components/auth/AuthStatusBox";
import { LoadingButton } from "@mui/lab";
import { sendPassSejamSuccessfully } from "../../metrix/metrixWrapper";

function SejamStatusPage() {
  const navigate = useNavigate();
  const authStatusMessage = useSelector(
    (state) => state.auth.authStatusMessage
  );

  const submitHandler = () => {
    if (authStatusMessage.data?.status === "INCOMPLETE") {
      if (!process.env.REACT_APP_BASE_URL.includes("dev")) {
        sendPassSejamSuccessfully({ is_successfully: "false" });
      }
      navigate("../referral");
    } else {
      navigate("../personal-info/first-name");
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "NOT_AVAILABLE":
        return "ثبت‌نام نشده";
      case "INCOMPLETE":
      case "INPROGRESS":
        return "نقص اطلاعات";
      case "REGISTERED":
        return "احراز هویت نشده";
      default:
        return "نامشخص";
    }
  };

  return (
    <>
      <AppBarContainer
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            استعلام وضعیت سجام
          </Typography>
        }
      />
      <PageContentContainer sx={{ overflow: "auto" }}>
        <Box>
          <Box
            sx={{
              boxShadow: (theme) => theme.shadows[2],
              width: "100%",
              minHeight: 108,
              borderRadius: "8px",
              p: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: "24px",
            }}
          >
            <img
              src={SejamStatusImage}
              width={60}
              height={60}
              alt="sejam status"
            />
            <Box
              sx={{
                ml: 5,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="subtitle1" color="secondary.main">
                وضعیت سجام
              </Typography>
              <Typography variant="subtitle1" color="red.main">
                {getStatusLabel(authStatusMessage.data?.status)}
              </Typography>
            </Box>
          </Box>
          {authStatusMessage.data?.message && (
            <AuthStatusBox
              title={authStatusMessage.data?.message?.title || ""}
              body={authStatusMessage.data?.message?.body || ""}
            />
          )}
        </Box>
        <Box
          sx={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <Box sx={{ width: "100%" }}>
            <LoadingButton
              onClick={submitHandler}
              sx={{
                borderRadius: "8px",
                typography: "h5",
                mt: "24px",
              }}
              variant="outlined"
              fullWidth
            >
              {authStatusMessage.data?.status === "INCOMPLETE"
                ? "متوجه شدم"
                : "ثبت نام به صورت عادی"}
            </LoadingButton>
          </Box>
        </Box>
      </PageContentContainer>
    </>
  );
}

export default SejamStatusPage;
